import NoteContext from "./NoteContext";
import React from "react";
import { useState } from "react";

const NoteState = (props) => {
    const host = "https://inotebook-wine.vercel.app"
    const notesInitial = []

    const [notes, setNotes] = useState(notesInitial)

    // GET ALL NOTES
    const getNotes = async () => {
        // USE API CALL REMAINING
        const response = await fetch(`${host}/api/notes/fetchallnotes`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'auth-token': localStorage.getItem('token')
            }
        });
        const json = await response.json();
        setNotes(json)
    }



    // ADD a Note
    const addNote = async (title, description, tag) => {
        // USE API CALL REMAINING
        const response = await fetch(`${host}/api/notes/addnote`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'auth-token': localStorage.getItem('token')
            },
            body: JSON.stringify({ title, description, tag })
        });
        const note = await response.json();
        setNotes(notes.concat(note))
    }

    // DELETE a Note
    const deleteNote = async (id) => {
        // USE API CALL REMAINING
        const response = await fetch(`${host}/api/notes/deletenote/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'auth-token': localStorage.getItem('token')
            }
        });
        const json = await response.json();
        setNotes(json)

        // LOGIC TO DELETE IN CLIENT SIDE
        const delNotes = notes.filter((notes) => { return notes._id !== id })
        setNotes(delNotes)

    }

    // EDIT a Note
    const editNote = async (id, title, description, tag) => {
        // API CALLS
        const response = await fetch(`${host}/api/notes/updatenote/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'auth-token': localStorage.getItem('token')
            },
            body: JSON.stringify({ title, description, tag })
        });
        const json = await response.json();
        console.log(json);


        let newNotes = JSON.parse(JSON.stringify(notes))
        // LOGIC TO EDIT IN CLIENT SIDE
        for (let index = 0; index < notes.length; index++) {
            const element = notes[index];
            if (element._id === id) {
                newNotes[index].title = title;
                newNotes[index].description = description;
                newNotes[index].tag = tag;
            }
            break;
        }
        setNotes(newNotes)

    }

    return (
        <NoteContext.Provider value={{ notes, addNote, deleteNote, editNote, getNotes }}>
            {props.children}
        </NoteContext.Provider>
    )
}
export default NoteState;
